import React, { Component } from 'react';
import { LoadingIndicator } from '@emorg-prd/react-standard';
import './index.css';

export default class LoaderIcon extends Component {
  render() {
    return <div className={"parentDisable"}>
    <LoadingIndicator
      className="em-u-margin loader"
      id="overlay"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
      color="inverted"
    />
  </div>
  }
}
